/**
 * KDS Avatar — Kintsugi Design System node 356:11110.
 *
 * | KDS   | `size` | Box     | Edit icon |
 * | ----- | ------ | ------- | --------- |
 * | Small | `sm`   | 24×24   | —         |
 * | Large | `lg`   | 100×100 | 20px      |
 */
export const avatarSize = {
  sm: '24px',
  lg: '100px',
} as const;

export const avatarFontSize = {
  sm: 'fontSizes.xxs',
  lg: 'fontSizes.2xl',
} as const;

/** Pencil icon on large editable hover — Figma 20×20. */
export const avatarEditIconSize = '20px';

/** Large editable hover overlay — Figma darkens the photo. */
export const avatarEditOverlayBg = 'blackAlpha.600';

export const avatarSizes = Object.keys(avatarSize) as Array<keyof typeof avatarSize>;

export type AvatarSize = keyof typeof avatarSize;
